import React, { useState, useContext, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useToast } from '../../../utility'
import { AcceptorContext } from '../../structures/contexts/AcceptorContext'
import CurrencyInput from '../../units/CurrencyInput/CurrencyInput'
import WalletBalance from '../WalletBalance/WalletBalance'
import { ApiService } from '../../../ayria'
import { MINIMUM_MANUAL_CASHOUT_AMOUNT } from '../../../config'
import ShebaInput, { isValidSheba, normalizeSheba } from '../ShebaInput'
interface WalletCashoutVipProps {
  amount?: string | number | null
  acceptorCode: string
  onSuccess: () => void
  theme: string
}

const WalletCashoutVip: FC<WalletCashoutVipProps> = ({ amount = null, acceptorCode, onSuccess, theme }) => {
  const api = new ApiService()
  const { t } = useTranslation()
  const toast = useToast()
  const btnClassName = theme === 'acceptor' ? 'btn btn-theme-platform text-white btn-sm' : 'btn btn-theme btn-sm'
  const [inprogress, setInprogress] = useState(false)
  const [dynamicAmount, setDynamicAmount] = useState<any>(amount)
  const [acceptorContext] = useContext<any>(AcceptorContext)
  const [sheba, setSheba] = useState(acceptorContext?.current?.shebaCode ?? '')
  const [shebaVerified, setShebaVerified] = useState(false)
  const [shebaLoading, setShebaLoading] = useState(false)
  const [accountInfo, setAccountInfo] = useState<any>()
  const [shebaError, setShebaError] = useState('')

  const handleCashout = async () => {
    const normalizedSheba = normalizeSheba(sheba)
    const owner = accountInfo?.accountOwners?.[0]

    console.log('Cashout started', {
      shebaVerified,
      normalizedSheba,
      shebaValid: isValidSheba(normalizedSheba),
      amount: dynamicAmount,
      amountValid: isAmountValid(),
      owner,
    })

    if (inprogress) {
      console.log('Cashout blocked: inprogress')
      return
    }

    if (!shebaVerified) {
      toast.error('ابتدا شماره شبا را استعلام کنید')
      return
    }

    if (!isValidSheba(normalizedSheba)) {
      toast.error('شماره شبا معتبر نیست')
      return
    }

    if (!isAmountValid()) {
      toast.error('مبلغ برداشت کمتر از حد مجاز است')
      return
    }

    if (!owner) {
      toast.error('اطلاعات صاحب حساب موجود نیست')
      return
    }

    setInprogress(true)

    try {
      const payload = {
        amount: dynamicAmount,
        senderAcceptorCode: acceptorCode,
        sheba: normalizedSheba,
        receiverFirstName: owner.firstName,
        receiverLastName: owner.lastName,
      }

      // console.log('Cashout payload:', payload)
      const res: any = await api.post('/wallet/cashout-vip', payload)
      // console.log('Cashout response:', res)
      if (res.ok) {
        toast.success(t('label.successfulOperation'))
        onSuccess()
      } else {
        toast.error(res)
      }
    } catch (error) {
      console.error('Cashout error:', error)

      toast.error('خطا در انجام عملیات برداشت')
    } finally {
      setInprogress(false)
    }
  }

  const lookupSheba = async (shebaNumber?: string) => {
    const normalizedSheba = normalizeSheba(shebaNumber ?? sheba)
    if (!isValidSheba(normalizedSheba) || inprogress) {
      return
    }
    setInprogress(true)
    setShebaVerified(false)
    setAccountInfo(undefined)
    try {
      const res: any = await api.get(`/acceptor-roles/lookup-sheba/${encodeURIComponent(normalizedSheba)}`)
      if (!res.ok) {
        toast.error(res)
        return
      }
      if (normalizeSheba(res.data?.iban) !== normalizedSheba) {
        toast.error('استعلام شبا ناموفق بود')
        return
      }

      const accountOwners = res.data.accountOwners
        // const accountOwners = typeof res.data.accountOwners === 'string' ? JSON.parse(res.data.accountOwners) : res.data.accountOwners
      // if (!Array.isArray(accountOwners) || accountOwners.length === 0) {
      //   toast.error('اطلاعات صاحب حساب دریافت نشد')
      //   return
      // }

      setAccountInfo({
        ...res.data,
        accountOwners,
      })
      setShebaVerified(true)
      toast.success('استعلام شبا با موفقیت انجام شد')
    } catch (error) {
      console.error('Sheba lookup error:', error)
      setShebaError('خطا در استعلام شماره شبا')
      toast.error('خطا در استعلام شماره شبا')
    } finally {
      setInprogress(false)
    }
  }

  const isAmountValid = () => {
    return +dynamicAmount >= MINIMUM_MANUAL_CASHOUT_AMOUNT
  }

  const canCashout = Boolean(
    !inprogress &&
      shebaVerified &&
      isAmountValid() &&
    // && Array.isArray(accountInfo?.accountOwners)
     accountInfo.accountOwners.length > 0
  )

  return (
    <div>
      <div>
        <label>
          نام فروشگاه <span className='text-bold'>{acceptorContext?.current?.acceptorName}</span>
        </label>
        <WalletBalance acceptorCode={acceptorCode} showScore={false} />
        <div className='row'>
          <span className='col-8'>مبلغ مورد نظر شمابرای انتقال به شبا : </span>
          <span className={`col-4 ${isAmountValid() ? '' : ' text-danger'}`}>
            {(+dynamicAmount).toLocaleString(navigator.language)} {t('label.riyal')}
          </span>
        </div>
        <br />
        <div className='form-group'>
          <CurrencyInput onValueChange={(value) => setDynamicAmount(+value)} defaultValue={dynamicAmount} />
        </div>
        <ShebaInput
          value={sheba}
          onChange={(value) => {
            setSheba(value)
            setShebaVerified(false)
            setAccountInfo(undefined)
            setShebaError('')
          }}
          onVerify={lookupSheba}
          loading={inprogress}
          verified={shebaVerified}
          error={shebaError}
        />

        {/* Account Information */}
        {shebaVerified && accountInfo?.accountOwners?.length > 0 && (
          <div className='card p-3 mt-3'>
            <div className='text-success mb-2'>
              <i className='fa fa-check-circle mr-2' />
              اطلاعات حساب تأیید شد
            </div>

            <div>
              صاحب حساب:
              <strong className='mr-2'>
                {accountInfo.accountOwners}
              </strong>
              <br />
              <small>{accountInfo.iban}</small>
              <br />
              <small>{accountInfo.accountStatus}</small>
            </div>
          </div>
        )}

        {/* Cashout Button - Immediately after account info */}
        <div className='mt-3'>
          <button
            type='button'
            className={btnClassName}
            style={{
              width: '100%',
              minHeight: '40px',
              fontSize: '16px',
              fontWeight: 700,
              letterSpacing: '0',
              borderRadius: '10px',
            }}
            onClick={handleCashout}
            disabled={!canCashout}>
            {inprogress ? 'لطفاً صبر کنید...' : 'انجام برداشت'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default WalletCashoutVip
